<template>
  <div>
    <div v-txt="4 * 5"></div>
  </div>
</template>

<script>
export default {
  directives: {
    txt(el, binding, vnode, oldVnode) {
      let s = JSON.stringify
      el.innerHTML =
        'name: ' +
        s(binding.name) +
        '<br>' +
        'rawName: ' +
        s(binding.rawName) +
        '<br>' +
        'value: ' +
        s(binding.value) +
        '<br>' +
        'expression: ' +
        s(binding.expression) +
        '<br>' +
        'argument: ' +
        s(binding.arg) +
        '<br>' +
        'modifiers: ' +
        s(binding.modifiers) +
        '<br>' +
        'vnode keys: ' +
        Object.keys(vnode).join(', ')
    }
  }
}
</script>

<style></style>
